import React, { useEffect } from 'react';

const Terms = props => {
  useEffect(() => {
    document.body.classList.add('white');

    return function cleanup(){
      document.body.classList.remove('white');
    }
  }, []);

  return <div className='shop-page transition'>
    <div className="content">
      <div className="inner">
        <h4>Akkurat Studios GmbH General Terms and Conditions</h4>
        <p>
          §1 Validity for business customers and term definitions<br />
          (1) The following general terms and conditions apply to all deliveries of goods between us and a consumer in the version valid at the time of the order.<br />
          <br />
          A consumer is any natural person who enters into a legal transaction for purposes that are predominantly outside their trade, business or profession (as defined in §13 of the German Civil Code).<br />
          <br />
          <br />
          §2 The formation of a contract, storage of the contract text<br />
          (1) The following provisions concerning contract conclusion apply to orders made via our online shop https://akkurat.tv/.<br />
          <br />
          (2) In the event of the conclusion of a contract, the contract is concluded with:<br />
          <br />
          Akkurat Studios GmbH<br />
          Rocco Kopecny<br />
          Besselstrasse 13<br />
          D-10969 Berlin<br />
          Register number: HRB 207153 B <br />
          Court of registry: District Court Berlin<br />
          <br />
          (3) The presentation of goods in our online shop is not a legally binding offer to enter into a contract, but is only a non-binding invitation to the consumer to place an order. By placing an order for goods, the consumer submits a binding offer to enter into a purchase contract.<br />
          (4) The following provisions apply when an order is received in our online shop: the consumer submits a binding contract offer by successfully completing the ordering procedure provided in our online shop.<br />
          <br />
          The order takes place in the following steps:<br />
          1) Selection of the desired goods<br />
          2) Confirmation by clicking on the ‘Order’ button<br />
          3) Checking the information in the shopping basket<br />
          4) Clicking on the ‘Checkout’ button<br />
          5) Logging in to the online shop after registration and entry of the log in details (email address and password).<br />
          6) Another review or correction of the entered information.<br />
          7) Binding submission of the order by clicking on the ‘Confirm order’ or ‘Buy’ button<br />
          Before the binding submission of the order and after checking the information they have entered, the consumer can click on the ‘Back’ button contained in the Internet browser they are using to return to the web page where the customer details are recorded and correct input errors or close the Internet browser to cancel the order process. We confirm receipt of the order immediately via an automatically generated email (‘order confirmation’). With this, we accept your offer.<br />
          <br />
          (5) Storage of the contract text for orders via our online shop: we will send you the order information and our general terms and conditions by email. You can also view the general terms and conditions at any time at https://akkurat.tv/. For security reasons, your order information will no longer be accessible online. <br />
          <br />
          <br />
          §3 Prices, delivery costs, payment, payment date<br />
          (1) The prices stated include VAT at the statutory rate and other price components. Delivery costs are not included.<br />
          <br />
          (2) The consumer can pay via advance payment, PayPal or credit card (Visa, Mastercard).<br />
          <br />
          (3) If the consumer selects advance payment, by doing so they undertake to pay the purchase price immediately after the conclusion of the contract.<br />
          <br />
          <br />
          §4 Delivery<br />
          (1) Unless we have clearly stated otherwise in the product description, all items offered by us are ready for immediate dispatch. Delivery will take place within a maximum of 10 working days. In the case of advance payment, the time allowed for delivery commences on the day after the payment order is sent to the bank responsible for the transfer, and for all other payment types, on the day after the conclusion of the contract. If the delivery deadline falls on a Saturday, Sunday or public holiday at the place of delivery, the time allowed for delivery ends on the next working day. <br />
          <br />
          (2) The risk of accidental loss and accidental deterioration of the sold goods does not pass to the buyer until the goods are handed over to the buyer. <br />
          <br />
          <br />
          §5 Retention of title<br />
          We retain ownership of the goods until the purchase price has been paid in full. <br />
          <br />
          ******************************************************************************************<br />
          <br />
          §6 The customer’s right of withdrawal as a consumer:<br />
          Consumer right of withdrawal<br />
          <br />
          Consumers are entitled to a right of withdrawal in accordance with the following provisions, whereby a consumer is any natural person who enters into a legal transaction for purposes that predominantly are outside their trade, business or profession:<br />
          <br />
          <br />
          Cancellation policy<br />
          <br />
          Right of withdrawal<br />
          <br />
          You have the right to withdraw from this contract within fourteen days without giving a reason. <br />
          <br />
          The withdrawal period is fourteen days from the day on which you or a third party designated by you, other than the carrier, took possession of the goods.<br />
          <br />
          To exercise your right of withdrawal, you must inform us,<br />
          Akkurat Studios GmbH<br />
          Rocco Kopecny<br />
          Besselstrasse 13<br />
          D-10969 Berlin<br />
          Email: info@akkurat.tv<br />
          <br />
          of your decision to withdraw from this contract by means of a clear declaration (e.g. a letter sent by post, fax or email). You may use the attached sample cancellation form for this, but it is not mandatory to do so. <br />
          <br />
          Consequences of withdrawal <br />
          <br />
          If you withdraw from this contract, we will reimburse all payments we have received from you, including delivery charges (with the exception of any additional costs resulting from your choosing a different method of delivery from the cheapest standard delivery offered by us), without delay and no later than fourteen days from the date on which we receive notice of your withdrawal from this contract. For this reimbursement, we will use the same means of payment that you used for the original transaction, unless expressly agreed otherwise with you; in no event will you be charged for this reimbursement. <br />
          <br />
          We may withhold reimbursement until we have received the goods back or until you have provided proof that you have returned the goods, whichever is the earliest. <br />
          <br />
          You must return or hand over the goods to us without delay and in any case within fourteen days at the latest from the day on which you inform us of your withdrawal from this contract. To meet the deadline, it is sufficient for you to dispatch the goods before the end of the fourteen-day period. <br />
          <br />
          You bear the direct costs of returning the goods.<br />
          <br />
          End of the cancellation policy <br />
          <br />
          ******************************************************************************************<br />
          <br />
          §7 Cancellation form<br />
          Sample cancellation form<br />
          (If you would like to withdraw from the contract, please fill in this form and return it to us).<br />
          To:<br />
          Akkurat Studios GmbH<br />
          Rocco Kopecny<br />
          Besselstrasse 13<br />
          D-10969 Berlin<br />
          Email: info@akkurat.tv<br />
          <br />
          I/we (*) hereby revoke the contract concluded by me/us (*) for the purchase of the following goods (*)/the provision of the following service (*)<br />
          <br />
          _____________________________________________________<br />
          <br />
          Ordered on (*)/received on (*)<br />
          <br />
          __________________<br />
          <br />
          Name of the consumer(s)<br />
          <br />
          _____________________________________________________<br />
          <br />
          Address of the consumer(s)<br />
          <br />
          <br />
          _____________________________________________________<br />
          <br />
          Signature of the consumer(s) (only for written communications)<br />
          <br />
          __________________<br />
          <br />
          Date<br />
          <br />
          __________________<br />
          (*) Delete as applicable.<br />
          <br />
          <br />
          §8 Warranty<br />
          The statutory warranty provisions apply.<br />
          <br />
          <br />
          <br />
          General terms and conditions as of June 2020.
        </p>
      </div>
    </div>
    <div className="image" style={{backgroundImage: 'url(/static/terms.jpg)'}} />
  </div>;
}

export default Terms;
